import 	Vue from 'vue'

// 过滤审核状态
Vue.filter('getReviewProgress',val => {
	switch(val){
		case 0:
			return '暂存'
			break;
		case 1:
			return '学校审核-未处理'
			break;
		case 2:
			return '学校审核-退回修改'
			break;
		case 3:
			return '学校审核-不通过'
			break;
		case 4:
			return '区级审核-未处理'
			break;
		case 5:
			return '区级审核-退回修改'
			break;
		case 6:
			return '区级审核-不通过'
			break;
		case 7:
		case 8:
		case 9:
		case 10:
			return '专家初审中'
			break;
		case 11:
			return '专家初审完成'
			break;
		case 12:
		case 13:
		case 14:
		case 15:
			return '专家复审中'
			break;
		case 16:
			return '专家复审完成'
			break;
		case 17:
		case 18:
		case 19:
		case 20:
			return '专家终审中'
			break;
		case 21:
			return '专家终审完成'
			break;
		case 22:
			return '立项审核-未处理'
			break;
		case 23:
			return '立项通过'
			break;
		case 24:
			return '立项不通过'
			break;
		default:
			return '未知状态'
	}
})

// 过滤学段
Vue.filter("stageTextFilters", (data) => {
  let stageOptions = [
    { id: "0", name: "幼儿园" },
    { id: "1", name: "小学" },
    { id: "2", name: "初中" },
    { id: "3", name: "高中" },
    { id: "4", name: "中/高职" },
    { id: "5", name: "其他" },
  ];
  let text = [];
  data.forEach((item) => {
    stageOptions.forEach((item1) => {
      if (item == item1.id) {
        text.push(item1.name);
      }
    });
  });
  return text.join(",");
});

// 过滤2021-03-25 10:00:00时间格式为2021-03-25
Vue.filter('getTime', val=>{
	if (val) {
		return val.slice(0,10)
	}else{
		return '没有该时间'
	}
})

// 过滤2021-03-25 10:00:00时间格式为2021-03-25 10:00
Vue.filter('getTimeToMinute', val=>{
	if (val) {
		return val.slice(0,-3)
	}else{
		return '没有该时间'
	}
})

// 过滤2021-03-25 10:00:00时间格式为03-25
Vue.filter('getMMddTime', val=>{
	if (val) {
		return val.slice(5,10)
	}else{
		return '没有该时间'
	}
})

// 课题管理
// 课题状态阶段
Vue.filter('getTopicStage', val=>{
	switch(val){
		case 0:
			return '开题'
			break;
		case 1:
			return '已开题校审未处理'
			break;
		case 2:
			return '已开题校审不通过'
			break;
		case 3:
			return '已开题区级审核未处理'
			break;
		case 4:
			return '已开题区级审核不通过'
			break;
		case 5:
			return '中期'
			break;
		case 6:
			return '中期校审未处理'
			break;
		case 7:
			return '中期校审不通过'
			break;
		case 8:
			return '中期区级审核未处理'
			break;
		case 9:
			return '中期区级审核不通过'
			break;
		// case 10:
		// 	return '结题申请'
		// 	break;
		// case 11:
		// 	return '结题申请校审未处理'
		// 	break;
		// case 12:
		// 	return '结题申请校审不通过'
		// 	break;
		// case 13:
		// 	return '结题申请区级审核未处理'
		// 	break;
		// case 14:
		// 	return '结题申请区级审核不通过'
		// 	break;
		case 15:
			return '结题'
			break;
		case 16:
			return '结题校审未处理'
			break;
		case 17:
			return '结题校审不通过'
			break;
		case 18:
			return '结题区级审核未处理'
			break;
		case 19:
			return '结题区级审核不通过'
			break;
		case 20:
		case 21:
		case 22:
		case 23:
			return '专家初审'
			break;
		case 24:
		case 25:
		case 26:
		case 27:
			return '专家复审'
			break;
		case 28:
		case 29:
		case 30:
		case 31:
			return '专家终审'
			break;
		case 32:
			return '拟结题未处理'
			break;
		case 33:
			return '不予结题'
			break;
		case 34:
			return '已结题'
			break;
		default:
			return '未知错误'
	}
})

Vue.filter('getTheTopicUnderStudyPhase', val=>{
	switch(val){
		case 0:
		case 1:
		case 2:
		case 3:
		case 4:
			return '开题'
			break;
		case 5:
		case 6:
		case 7:
		case 8:
		case 9:
			return '中期'
			break;
		// case 10:
		// case 11:
		// case 12:
		// case 13:
		// case 14:
		// 	return '结题申请'
		// 	break;
		case 15:
		case 16:
		case 17:
		case 18:
		case 19:
		case 20:
		case 21:
		case 22:
		case 23:
		case 24:
		case 25:
		case 26:
		case 27:
		case 28:
		case 29:
		case 30:
		case 31:
		case 32:
		case 33:
			return '结题'
			break;
		case 34:
			return '已结题'
			break;
		case 35:
			return '拟结题退回修改'
			break;
		default:
			return '已结题'
			break;
	}
})

// 将月份转换为年月
Vue.filter('formatTime', val=>{
	let year = Math.floor(val/12)
	let month = val%12
	return `${year>0?year+'年':''}${month>0?month+'个月':''}`
})
